module.exports = __webpack_public_path__ + "static/img/instagram_icon.af157a9.svg";